<ejs-grid #grid
          class="grid-with-toolbar grid-no-filter"
          width="100%" rowHeight="38"
          [dataSource]="selectedSession.registrations"
          [allowPaging]='true'
          [allowSorting]='true'
          [allowFiltering]="true"
          [filterSettings]="filterSettings"
          [pageSettings]="pageSettings">
  <e-columns>
    <e-column headerText="{{'i18n.domain.parking-ranger-sessions.grid.time' | translate}}"
              field='registrationDateTime'
              clipMode="EllipsisWithTooltip"
              type="date"
              format="dd.MM.yyyy HH:mm">
    </e-column>
    <e-column headerText="{{'i18n.domain.parking-ranger-sessions.grid.name' | translate}}"
              field='parker.lastName'
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{ data.knownTag?.parker ? data.knownTag.parker.firstName + ' ' + data.knownTag.parker.lastName : ''}}
      </ng-template>
    </e-column>
    <e-column headerText="{{'i18n.domain.parking-ranger-sessions.grid.license-plate' | translate}}"
              field='knownTag.controlPlateNumber'
              clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          <span class="text-uppercase">{{data.knownTag?.countryCode ?? data.unknownParkerTagCountryCode }} {{data.knownTag?.controlPlateNumber ?? data.unknownParkerTagControlPlateNumber}}</span>
        </ng-template>
    </e-column>
    <e-column headerText="{{'i18n.domain.parking-ranger-sessions.grid.zone' | translate}}"
              field='registeredZoneName'
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{data.registeredZoneName}}
      </ng-template>
    </e-column>
    <e-column headerText="" width="70px">
      <ng-template #template let-data>
      @if(data.offense !== 0) {
        <span class="icon-warning--alt--filled text-danger me-2"></span>
      }
      @if (data.penaltyIssued) {
        <span class="icon-currency--dollar"></span>
      }
      </ng-template>
    </e-column>
  </e-columns>
</ejs-grid>
